import styled from 'styled-components';

export const PhoneDialogContainer = styled.div`
  width: 500px;
  min-height: 200px;
  border: 1px solid var(--primary);
  background: var(--background);
  color: var(--primary);
  border-radius: 10px;
  padding: 1rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  header {
    width: 100%;
    display: flex;
    align-items: center;
    h1 {
      flex: 1;
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--primary);
      text-align: center;
    }
    svg {
      cursor: pointer;
    }
  }
`;

export const PhoneContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  footer {
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    margin-top: 1rem;

    button:first-child {
      background-color: transparent;
      border: 1px solid var(--primary);
      color: var(--primary);
      &:hover {
        background-color: red;
        border: 1px solid red;
        color: white;
      }
    }
  }
`;

export const PhoneFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  p {
    color: black;
    font-size: 0.875rem;
    text-align: left;
  }
  input {
    width: 100%;
    padding: 0.5rem !important;
    border: 1px solid var(--primary);
    border-radius: 5px;
    height: 40px !important;
  }
`;
